import { Component, OnInit, Output, Input, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { StaticValueService } from '../../../shared/services/static-value.service';


@Component({
    selector: 'app-address-format-display',
    templateUrl: './address-format-display.component.html',
    styleUrls: ['./address-format-display.component.scss']
})
export class AddressFormatDisplayComponent implements OnInit, OnChanges {
  @Input() field: string;
  @Input() addressObject: any;
  @Input() fieldDisplayName: string;
  @Input() country: string;
  @Input() canValidate: Boolean;
  @Input() prevAddressObject?: any;
  @Input() validationMode: string;
  @Input() displayIcon: Boolean = false;
  
  public addressFormatObject = {
    
  }
  public addressDisplayArray= [];
  public staticDDlist;

  constructor(public staticDDlistService: StaticValueService) { }

    transform(country): any {
        function compare(a, b) {
          if (a.order < b.order) {
            return -1;
            }
          if (a.order > b.order) {
             return 1; }
          return 0;
        }

        // default case
        this.addressDisplayArray = [];
        if (country === '' || country === undefined || this.addressFormatObject[country] === undefined) {
            country = 'default';
        }
        if (country === 'none') {
            country = this.addressObject.country;
        }
        for (let fieldDisplayObject in this.addressFormatObject[country]) {
            if (this.addressFormatObject[country].hasOwnProperty(fieldDisplayObject)) {
                if (this.addressFormatObject[country][fieldDisplayObject]['visibility'] === true) {
                    let temp = {
                        'visibility': true,
                        'fieldName': this.addressFormatObject[country][fieldDisplayObject]
                    }
                    this.addressDisplayArray.push(temp);
                } else {
                    let temp = {
                        'visibility': false,
                        'fieldName': this.addressFormatObject[country][fieldDisplayObject]
                    }
                    this.addressDisplayArray.push(temp)
                }
            }
        }
        this.addressDisplayArray.sort(compare);
    }

  ngOnInit() {
    this.staticDDlist = this.staticDDlistService.staticData.staticDD;
    this.addressFormatObject = JSON.parse(JSON.stringify(this.staticDDlist.addressFormats));
    this.transform(this.addressObject.country);
  }
  ngOnChanges(changes: SimpleChanges) {
    // only run when property "country" changed
    if (changes['country']) {
    }

}
}
